import DefaultLayout from './default-layout.component';

export { DefaultLayout };
